module.exports = __webpack_public_path__ + "static/media/0030_IMG_LE_SOL_MEGALITH_MEGABLACK.65bd3e1e.png";